module.exports = __webpack_public_path__ + "static/media/UncheckedCheckboxIcon.8b33647d.svg";